// extracted by mini-css-extract-plugin
export var bestFor = "x_bz";
export var ctaButton = "x_by";
export var icons = "x_bx";
export var mainHeadRow = "x_bv";
export var secondaryHeadRow = "x_bw";
export var tableContainer = "x_bt";